import types from './types'
import firebase from 'firebase/app'
import 'firebase/firestore'
import globaltypes from '../globaltypes'

export default {
  [types.actions.fill]: context => {
    firebase.firestore().collection('crops')
      .onSnapshot(function (snapshot) {
        snapshot.docChanges().forEach(function (change) {
          var data = change.doc.data()
          data.key = change.doc.id
          // data.languageCode = data.languageCode || 'nl'
          delete data.languageCode

          if (change.type === 'added') {
            context.commit(types.mutations.add, data)
          }
          if (change.type === 'modified') {
            context.commit(types.mutations.edit, data)
          }
          if (change.type === 'removed') {
            context.commit(types.mutations.delete, data)
          }
        })
        context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'crops', val: true })
      })
  },
  [types.actions.filter]: (context, category) => {
    context.commit(types.mutations.filterCrops, category)
  }
}
